import { Link } from 'react-router-dom'
import styles from '../../styles/common/Navbar.module.scss'

interface NavItemProps {
  label: string
  path: string
  icon?: React.ReactNode
  isActive?: boolean
  onClick?: () => void
  isLogout?: boolean
  showLabel?: boolean
}

const NavItem = ({
  label,
  path,
  icon,
  isActive,
  onClick,
  isLogout,
  showLabel = true,
}: NavItemProps) => {
  if (isLogout) {
    return (
      <li className={styles.navItemContainer}>
        <button
          className={`${styles.navItem} ${styles.logoutButton}`}
          onClick={onClick}
          type="button"
          title={!showLabel ? label : undefined}
        >
          <span className={styles.itemContent}>
            {icon && <span className={styles.iconWrapper}>{icon}</span>}
            {showLabel && <span className={styles.label}>{label}</span>}
          </span>
        </button>
      </li>
    )
  }

  return (
    <li className={styles.navItemContainer}>
      <Link
        to={path}
        className={`${styles.navItem} ${isActive ? styles.activeItem : ''}`}
        onClick={onClick}
      >
        <span className={styles.itemContent}>
          {icon && <span className={styles.iconWrapper}>{icon}</span>}
          {showLabel && <span className={styles.label}>{label}</span>}
        </span>
      </Link>
    </li>
  )
}

export default NavItem
